import apiClient from '../api-client';
import type { UserWithoutPassword, CreateUserRequest, UpdateUserRequest, PaginatedResponse, PaginationParams } from '@geely/shared';

export const usersApi = {
  list: () =>
    apiClient.get<UserWithoutPassword[]>('/users'),

  listPaginated: (params: PaginationParams) =>
    apiClient.get<PaginatedResponse<UserWithoutPassword>>('/users', { params }),

  getById: (id: string) =>
    apiClient.get<UserWithoutPassword>(`/users/${id}`),

  create: (data: CreateUserRequest) =>
    apiClient.post<UserWithoutPassword>('/users', data),

  update: (id: string, data: UpdateUserRequest) =>
    apiClient.patch<UserWithoutPassword>(`/users/${id}`, data),

  delete: (id: string) =>
    apiClient.delete(`/users/${id}`),
};
